import React, { MouseEvent } from 'react';
import List from 'components/list/List';
import { Surgerie } from 'types/surgerie';
import SurgerieItemModule from '../../../open/list/module/SurgerieItemModule';
import SurgerieClosedMenu from '../menu/SurgerieClosedMenu';
import { useSurgerie } from '../../hooks/useSurgerie';

type SurgerieClosedListModuleProps = {
  surgeries: Surgerie[];
};

const SurgerieClosedListModule: React.FC<SurgerieClosedListModuleProps> = ({ surgeries }) => {
  const { anchorEl, setAnchorEl, setSelectedSurgerie } = useSurgerie();

  function handleActionClick(event: MouseEvent<HTMLButtonElement>, surgerie: Surgerie) {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedSurgerie(surgerie);
  }

  return (
    <>
      {anchorEl && <SurgerieClosedMenu anchorEl={anchorEl} />}
      <List>
        {surgeries.map(surgerie => (
          <SurgerieItemModule key={surgerie.id_int} surgerie={surgerie} onActionClick={handleActionClick} />
        ))}
      </List>
    </>
  );
};

export default SurgerieClosedListModule;
